import React from 'react';
import Attachment from "../../../model2/attachment/attachment";
import {AttachFileMode} from "../const";
import AttachmentView from "../attachment-view/attachment-view";
import {AttachmentSystemType} from "../../../model2/attachment/@types";

type Props = {
    attachments             : any // object ? Attachment models ?
    hiddenAttachmentsIds    : any[]
    mode                    : AttachFileMode
    onPreview?              : callback
    onAddToMessage?         : callback
    onRemove?               : callback
    className?              : string
}

// const debug = "AttachmentsListByType"
const debug = false

export default class AttachmentsListByType extends React.Component<Props> {

    static defaultProps = {
        hiddenAttachmentsIds: []
    }

    constructor(props:Props) {
        super(props);
    }

    onPreview = (attachment:Attachment) => {
        debug && console.log(debug, "onPreview() attachment=", attachment)
        if (this.props.onPreview) this.props.onPreview(attachment)
        else gd.attachments.preview(attachment, this.props.attachments);
    }

    render() {

        const {attachments} = this.props

        if (attachments.isEmpty) return false;

        const withPreview = attachments.withPreviewAndNotInMessage
        let withoutPreview: Attachment[] = []

        // if(this.props.isCustom) {
        if(this.props.attachments.models[0]?.systemType === AttachmentSystemType.CUSTOM) {
            withoutPreview = attachments.allAttachments
        }
        else{
            withoutPreview = attachments.withoutPreviewAndNotInMessage
        }

        return (
            <div className={Classes(this.props.className)}>

                {!_.isEmpty(withPreview) && this.props.attachments.models[0]?.systemType !== AttachmentSystemType.CUSTOM &&
                <div className={Classes("ui5-attachments-list")}>
                    {withPreview.map((attachment:Attachment)=>{
                        return <AttachmentView key            = {attachment.fileId}
                                               attachment     = {attachment}
                                               onPreview      = {this.onPreview}
                                               onRemove       = {this.props.onRemove}
                                               onAddToMessage = {this.props.onAddToMessage}
                                               mode           = {this.props.mode}
                        />
                    })}
                </div>}

                {!_.isEmpty(withoutPreview) &&
                <div className={Classes("ui5-attachments-list")}>
                    {withoutPreview.map((attachment:Attachment)=>{
                        return <AttachmentView key            = {attachment.fileId}
                                               attachment     = {attachment}
                                               onPreview      = {this.onPreview}
                                               onRemove       = {this.props.onRemove}
                                               onAddToMessage = {this.props.onAddToMessage}
                                               mode           = {this.props.mode}/>
                    })}
                </div>}

            </div>
        );
    }
}
